(function () {
  function initSizeGuideLightbox() {
    const containers = document.querySelectorAll('.size-guide-content');
    if (containers.length === 0) return;

    // Wait for PhotoSwipe to be available
    if (!window.FoxTheme || !window.FoxTheme.PhotoSwipeLightbox) {
      setTimeout(initSizeGuideLightbox, 100);
      return;
    }

    containers.forEach(container => {
      const images = container.querySelectorAll('img');
      images.forEach((img, index) => {
        img.addEventListener('click', (e) => {
          e.preventDefault();
          
          const dataSource = Array.from(images).map(image => {
            return {
              src: image.src,
              width: image.naturalWidth || image.width,
              height: image.naturalHeight || image.height,
              alt: image.alt
            };
          });

          const lightbox = new window.FoxTheme.PhotoSwipeLightbox({
            dataSource: dataSource,
            pswpModule: window.FoxTheme.PhotoSwipe,
            bgOpacity: 0.9,
            index: index,
            zoom: false,
            close: false,
            counter: false,
            preloader: false,
          });
          
          lightbox.on('uiRegister', () => {
            lightbox.pswp.ui.registerElement({
              name: 'close-zoom',
              ariaLabel: 'Close size guide',
              order: 2,
              isButton: true,
              html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
              onClick: (event, el) => {
                lightbox.pswp.close();
              },
            });
          });

          lightbox.init();
          lightbox.loadAndOpen(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideLightbox);
  } else {
    initSizeGuideLightbox();
  }

  // Also re-init when Shopify section is loaded in editor
  document.addEventListener('shopify:section:load', initSizeGuideLightbox);
})();
